export const getFacebookShareLink = (url: string) => {
  return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
};

export const getLinkedinShareLink = (url: string) => {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
};
